import { IRecord, IRecordType, IRect, IRectType } from 'annotation-tools/utils';
import uuidv4 from 'uuid/v4';

// immutable object generator
export const IAnnotation = IRecord<AnnotationType>({
  uuid: uuidv4(),
  labelId: 0,
  rect: IRect()
});

// immutable type
export type IAnnotationType = IRecordType<AnnotationType>;

type AnnotationType = {
  uuid: string;
  labelId: number;
  rect: IRectType;
};
